import { createApp } from 'vue';
import PerfectScrollbar from 'vue3-perfect-scrollbar';

import { store, storeKey } from '@/store';
import { IComponents, IComponent } from './IVue';

const router = require('../routs/router').default;

class Vue {
  components: IComponents;

  constructor() {
    this.components = {};
  }

  /** Добавление комопнента Vue для работы с ним на странице */
  setComponent(vueComponent: IComponent) {
    try {
      if (vueComponent) {
        // eslint-disable-next-line no-underscore-dangle
        const fileName = vueComponent?.__file?.match(/[a-zA-Z]+\.vue$/)?.[0];
        // eslint-disable-next-line no-underscore-dangle
        const componentName = vueComponent?.name ?? vueComponent?.__name ?? fileName?.slice(0, -4);

        // console.log(fileName?.slice(0, -4));

        if (!vueComponent?.name && componentName) {
          this.components[componentName] = {
            ...vueComponent,
            name: componentName,
          };
        } else if (componentName) {
          this.components[componentName] = vueComponent;
        } else {
          // eslint-disable-next-line no-underscore-dangle
          throw new Error(`try set vue component Error`);
        }
      } else {
        throw new Error(`SetComponent is empty ${vueComponent}`);
      }
    } catch (err) {
      console.error(err, vueComponent);
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  createPropsFromAttributes = (dom: HTMLDivElement) => {
    try {
      const { dataset } = dom;
      const params: { [key: string]: string } = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const key in dataset) {
        // eslint-disable-next-line no-continue
        if (key === 'vue') continue;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        params[key] = JSON.parse(dataset[key]);
      }

      return params;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  // _setGlobalComponents(app) {
  //   const { components } = this;
  //
  //   for (const key in components) {
  //     app.component(key, components[key]);
  //   }
  // }

  createComponent(el: HTMLDivElement) {
    // return new Promise((resolve) => {
    const componentName = el.dataset.vue;
    el.classList.add('init');

    if (componentName && componentName in this.components) {
      const component = this.components[componentName];

      const app = createApp(
        {
          ...component,
          // mounted() {
          //   if (component.mounted) {
          //     component?.mounted.call(this);
          //   }
          //   resolve(this);
          // },
        },
        this.createPropsFromAttributes(el)
      );
      // this._setGlobalComponents(app);
      app.config.performance = true;

      app.use(store, storeKey);
      app.use(router);

      app.use(require('vue-universal-modal').default, {
        teleportTarget: '#modals',
      });

      app.use(PerfectScrollbar);

      app.component('SlideUpDown', require('vue3-slide-up-down').default);

      app.mount(el);
    } else {
      console.error(`component: ${componentName} is undefined`);
      // resolve(undefined);
    }
    // });
  }

  init() {
    try {
      const items = document.querySelectorAll('[data-vue]:not(.init)');

      // const options = {
      //   root: null,
      //   rootMargin: '100px',
      //   threshold: 1,
      // };
      // const observer = new IntersectionObserver((entries) => {
      //   entries.forEach(async (entry) => {
      //     if (entry.isIntersecting) {
      //       const { target } = entry;
      //       observer.unobserve(target);
      //       this.createComponent(target);
      //     }
      //   });
      // }, options);
      //
      // async function* generateItem() {
      //   for (let i = 0; i < items.length; i++) {
      //     if (items[i].offsetTop - window.scrollY < window.innerHeight) {
      //       await this.createComponent(items[i]);
      //     } else {
      //       observer.observe(items[i]);
      //     }
      //
      //     yield;
      //   }
      // }
      //
      // const generatorItems = generateItem.call(this);
      //
      // (async () => {
      //   for await (const value of generatorItems) {
      //   }
      // })();
      //
      // document.addEventListener(
      //   'scroll',
      //   () => {
      //     document.querySelectorAll('[data-vue]:not(.init)').forEach((el) => {
      //       this.createComponent(el);
      //       observer.unobserve(el);
      //     });
      //   },
      //   {
      //     once: true,
      //   }
      // );

      items.forEach((el) => {
        this.createComponent(el as HTMLDivElement);
      });
    } catch (err) {
      console.error(err);
    }
  }
}

export default Vue;
